'use client'
import OrganizationsLanding from '../components/OrganizationsLanding'
import CTA from '../components/CTA'

export default function OrganizationsPage() {
  return (
    <>
      <OrganizationsLanding />
      <CTA />
    </>
  )
}
